<template>
  <div v-if="highlightedCars?.length">
    <SharedHeadlineWithCta
      class="container container--page-content"
      :title="component.featuredCarsTitle"
      :description="component.featuredCarsDescription"
      :cta="component.cta"
      :invertedColor="component.featuredCarsInvertedColor"
    />
    <FeaturedCarsSlider :invertedColor="component.featuredCarsInvertedColor" class="mt-11 md:mt-14 lg:mt-16" :cars="highlightedCars" />
  </div>
</template>

<script setup lang="ts">
  import type { GraphQLFeaturedCars, GraphQLCarDetail } from '~/types/graphql';
  import type { FeaturedVehiclesQueryParams, AllVehiclesVehicle } from '~/types/api';

  import FeaturedCarsSlider from './FeaturedCarsSlider.vue';

  defineProps<{
    component: GraphQLFeaturedCars;
  }>();

  const { locale } = useI18n();

  const cacheKey = computed(() => `featured-cars-${locale.value}`);

  const router = useRouter();

  // Query for featured cars using vehicles API
  const query = computed<FeaturedVehiclesQueryParams>(() => {
    const query: FeaturedVehiclesQueryParams = {
      locale: locale.value,
      count: 10,
      order_field: 'internal_vehicle_no',
      order_direction: 'desc',
      // INFO: min pictcure above 5 now representes cars that are 'ready' but not yet in
      // this intermediate state does not have proper name, but the picture count
      // is a good indicator aggreed with the client
      min_pictures_count: 6,
    };

    // if on vehicles-kaufen page
    if (router.currentRoute.value.name?.toString().toLowerCase().includes('autos-kaufen')) {
      if (router.currentRoute.value.params.make) {
        query.make = router.currentRoute.value.params.make as string;
      }
      if (router.currentRoute.value.params.body_style) {
        query.body_style = router.currentRoute.value.params.body_style as string;
      }
      if (router.currentRoute.value.params.slug) {
        query.vehicle = router.currentRoute.value.params.slug as string;
      }
    }

    return query;
  });

  const { data: highlightedCars } = await useAsyncData<AllVehiclesVehicle[]>(cacheKey.value, () => $fetch('/api/vehicles/featured-vehicles', { query: query.value }), {
    watch: [query, locale],
  });
</script>
